// extracted by mini-css-extract-plugin
module.exports = {"container":"youTubeEmbedVideo__container___2A_LZ","youtube":"youTubeEmbedVideo__youtube___1R5SR"};